import { Twitter, Facebook, MessageCircle, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar() {
  const url = typeof window !== "undefined" ? window.location.origin : "";
  const text = "Help send Camden Clichee (Wookies #10) to the NATTYS 2026 — Native American Junior Nationals, Mesa AZ 🏀";

  const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — pass it on!");
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <section data-testid="share-section" className="relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="bg-[#FF007F] text-black p-8 md:p-12 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-7">
            <div className="text-[10px] uppercase tracking-[0.35em] text-black/70">
              Boost the signal
            </div>
            <h2 className="font-display uppercase tracking-tight text-4xl md:text-5xl mt-2 leading-[0.9] text-black">
              Can't donate? Share.<br />It's just as powerful.
            </h2>
          </div>
          <div className="md:col-span-5 flex flex-wrap gap-3 md:justify-end">
            <a
              data-testid="share-twitter-button"
              href={twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-black text-white px-5 py-3 font-bold uppercase tracking-[0.18em] hover:-translate-y-0.5 transition-transform"
            >
              <Twitter className="h-4 w-4" /> X
            </a>
            <a
              data-testid="share-facebook-button"
              href={facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-black text-white px-5 py-3 font-bold uppercase tracking-[0.18em] hover:-translate-y-0.5 transition-transform"
            >
              <Facebook className="h-4 w-4" /> Facebook
            </a>
            <a
              data-testid="share-whatsapp-button"
              href={whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-black text-white px-5 py-3 font-bold uppercase tracking-[0.18em] hover:-translate-y-0.5 transition-transform"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            <button
              data-testid="share-copy-link-button"
              onClick={copy}
              className="inline-flex items-center gap-2 bg-black text-white px-5 py-3 font-bold uppercase tracking-[0.18em] hover:-translate-y-0.5 transition-transform"
            >
              <LinkIcon className="h-4 w-4" /> Copy
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
